<!-- 为你推荐 -->
<template>
<div>
    <swiper :options="swiperOptions">
        <swiper-slide v-for="item in list" :key="item.id">
            <div class="ig"><a :href="item.url" target="_blank">
                <img class="pc" :src="item.pc" alt="">
                <img class="m" :src="item.m" alt="">
            </a></div>
            
          
        </swiper-slide>
        
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    
</div>
</template>
<script>
export default {
    name:'SaleBanner',
    data(){
        return {
             // 轮播图配置
            swiperOptions: {
                //spaceBetween: 30,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                //slidesPerView: 2,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
            outbreakLoading:true,
            list:[
                {
                    'pc':'https://media4.imgyb.xyz/media/v1/image/725c1fb451b03205d7a8a9751a6918a1.jpeg',
                    'm':'https://media1.imgyb.xyz/media/v1/image/ebb9b46ce9b2dc4ea8ac713652e61188.jpeg',
                    'url':'https://forum.yorkbbs.ca/detail/9278f17a-87df-4acf-b524-53a74d522723?topic=immi',
                },
                {
                    'pc':'https://media4.imgyb.xyz/media/v1/image/7f89997482536f79a7236f265a86df33.jpeg',
                    'm':'https://media7.imgyb.xyz/media/v1/image/4719510dca9a4e931c8eb5bebd157d21.jpeg',
                    'url':'https://forum.yorkbbs.ca/detail/3e6feafc-bc49-4317-b43f-87014a53f9f4?topic=yoga'
                },   
            ]
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.swiper-container{
    padding-bottom: 37px;
    margin-top: -40px;
    margin-bottom: 40px;
    .swiper-wrapper{
        .swiper-slide{
            .m{display: none;}
        }
    }
}
@media screen and (max-width:768px){
    /deep/.swiper-container{
    padding-bottom: 37px;
    margin-top: 0;
    margin-bottom: 0;
    .swiper-wrapper{
        .swiper-slide{
            .m{display: block;}
            .pc{display: none;}
        }
    }
}
}
</style>